import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const CalendarIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M22 4a1 1 0 0 1 1 1v1h1a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h1V5a1 1 0 0 1 2 0v1h10V5a1 1 0 0 1 1-1ZM7 14v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V14H7Zm1-6a1 1 0 0 0-1 1v3h18V9a1 1 0 0 0-1-1h-1v1a1 1 0 1 1-2 0V8H11v1a1 1 0 1 1-2 0V8H8Z" />
  </BaseIcon>
);
